module.exports = __webpack_public_path__ + "static/media/demo-11.84dcaf03.jpg";